import { useUserStore } from "../store/modules/user";
import { ServerName } from "../utils/constants/serverName";
import axios from "../utils/http/axios";
export const getAsset = async (asset: string, tenantId: number): Promise<string> => {
  const store = useUserStore();

  const assetEndpoint = `${ServerName}/tenantprofile/${tenantId}/asset?type=${asset}`;
  const response = await axios.get(assetEndpoint, {
    responseType: "arraybuffer",
  });
  try {
    const blob = new Blob([response.data]);
    const buffer = await blob.arrayBuffer();
    const base64 = btoa(new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), ""));
    return Promise.resolve(base64);
  } catch (error) {
    console.warn(error);
    console.warn(`Could not load asset at ${assetEndpoint}. Returning empty white background`);
    return Promise.resolve("iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=");
  }
};

export const saveAsset = async (assetType: string, data: FormData) => {
  const store = useUserStore();
  const tenantId = store.tenantId || 0;

  const assetEndpoint = `${ServerName}/tenantprofile/${tenantId}/asset?type=${assetType}`;
  try {
    const response = await axios.put(assetEndpoint, data);
    return Promise.resolve(response);
  } catch (error) {
    console.warn(`Could not save asset at ${assetEndpoint}. Returning empty white background`);
    return Promise.reject("Unable to save");
  }
};

export const deleteAsset = async (asset: string): Promise<void> => {
  const store = useUserStore();
  const tenantId = store.tenantId || 0;
  const assetEndpoint = `${ServerName}/tenantprofile/${tenantId}/asset?type=${asset}`;

  try {
    await axios.delete(assetEndpoint);
  } catch (error) {
    console.error(`Could not delete asset at ${assetEndpoint}`, error);
    throw error;
  }
};
